import React from "react";

const Footer = () => {
  return (
            <div className="loginFootBox">
                {/* <div className="indiaCasino">
                    <img className="img-fluid" src="/images/indian-casino.gif" alt="" />
                </div> */}
                <div className="loginFootLogoBdy">
                  <div className="imgFootLogo">
                    <img className="img-fluid h-25" src="/images/ssl.png" alt="" />
                  </div>
                  <div className="imgFootLogo">
                    <img className="img-fluid h-15" src="/images/betfair.png" alt="" />
                  </div>
                  <div className="imgFootLogo">
                    <img className="img-fluid h-22" src="/images/18-plus.png" alt="" />
                  </div>
                  <div className="imgFootLogo">
                    <img className="img-fluid h-40 w-40" src="/images/aviator1.png" alt="" />
                  </div>
                  <div className="imgFootLogo">
                    <img className="img-fluid h-22" src="/images/download-android.png" alt="" />
                  </div>
                </div>
                <div className="loginFootLogoBdyTow">
                  <div className="imgFootLogo">
                    <img className="img-fluid h-15" src="/images/comission.png" alt="" />
                  </div>
                  <div className="imgFootLogo">
                    <img className="img-fluid h-15" src="/images/gambleaware.png" alt="" />
                  </div>
                  <div className="imgFootLogo">
                    <img className="img-fluid h-15" src="/images/cogra.png" alt="" />
                  </div>
                </div>
              </div>
 );
};

export default Footer;
